import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { MyTypography } from '../../common/components';
import 'yup-phone';
import { gridSpacing } from '../../../common/themes/constants';
import { isEmpty } from 'lodash';
import NotificationOptions from './NotificationOptions';
import clientGraphql from '../../../common/apollo-graphql';

const OTP_KEYS = ['RECEIVE_OTP_VIA_EMAIL', 'RECEIVE_OTP_VIA_SMS'];

export const initialValues = {
  notification: parseInt('111', 2),
};

export default function UpdateUserNotificationForm({
  notificationSettings = [],
  clinicsNotificationSettings = [],
  handRefetch = null,
  userData = null,
  onSubmit,
  save_clinic_notification_settings,
}) {
  const [notificationsBinary, setNotificationsBinary] = useState({});
  const [uiNotificationSettings, setUiNotificationSettings] = useState([]);

  useEffect(() => {
    if (!isEmpty(userData)) {
      const notificationBi = {
        ...Object.fromEntries(
          userData.notifications.map(v => [v.label.replace(' ', '_'), v.value]),
        ),
      };
      setNotificationsBinary(notificationBi);
      //   updateNotificationValue();
    }
  }, [setNotificationsBinary, userData]);

  useEffect(() => {
    setUiNotificationSettings(notificationSettings);
  }, [notificationSettings]);

  useEffect(() => {
    if (!isEmpty(notificationsBinary) && !isEmpty(userData)) {
      updateNotificationValue();
    }
  }, [userData, updateNotificationValue, notificationsBinary]);

  const handleNotificationChange = useCallback(
    (value, notification) => {
      const isOtpOption = OTP_KEYS.includes(notification?.key);
      const nextValue = !notification.value;

      if (isOtpOption && !nextValue) {
        const otherOtpEnabled = uiNotificationSettings.some(setting => {
          if (!OTP_KEYS.includes(setting?.key) || setting?.key === notification?.key) {
            return false;
          }

          return setting.value;
        });

        if (!otherOtpEnabled) {
          return;
        }
      }

      const updatedUiNotificationSettings = uiNotificationSettings.map(setting =>
        setting?.key === notification?.key
          ? { ...setting, value: nextValue }
          : setting,
      );
      setUiNotificationSettings(updatedUiNotificationSettings);

      const binary = {
        ...notificationsBinary,
        [notification.label.replace(' ', '_')]: nextValue,
      };
      setNotificationsBinary(binary);
    },
    [notificationsBinary, uiNotificationSettings],
  );

  const handleClinicNotificationChange = useCallback(
    (index, notification) => {
      notification.value = !notification.value;

      save_clinic_notification_settings({
        client: clientGraphql,
        variables: { clinicId: notification.id, notificationSettings: notification.value ? 1 : 0 },
      }).then(res => {
        handRefetch();
      });
    },
    [handRefetch, save_clinic_notification_settings],
  );

  const updateNotificationValue = useCallback(() => {
    var strNotification = '';
    Object.keys(notificationsBinary)
      .reverse()
      .forEach(function(key, index) {
        if (notificationsBinary[key]) {
          strNotification += '1';
        } else {
          strNotification += '0';
        }
      });
    var notificationInt = parseInt(strNotification, 2);

    onSubmit({ notification: notificationInt });
  }, [notificationsBinary, onSubmit]);

  const otpNotificationSettings = uiNotificationSettings.filter(notification =>
    OTP_KEYS.includes(notification?.key) ||
    notification?.label?.toLowerCase().includes('otp'),
  );
  const enabledOtpCount = otpNotificationSettings.filter(notification => notification.value).length;
  const otpNotificationSettingsWithGuard = otpNotificationSettings.map(notification => ({
    ...notification,
    disabled: enabledOtpCount === 1 && notification.value,
  }));

  const nonOtpNotificationSettings = uiNotificationSettings.filter(notification =>
    !(OTP_KEYS.includes(notification?.key) ||
    notification?.label?.toLowerCase().includes('otp')),
  );

  return (
    <Grid container spacing={gridSpacing}>
      {!isEmpty(clinicsNotificationSettings) ? (
        <>
          <Grid item xs={12}>
            <MyTypography gutterBottom variant="h4" style={{ marginTop: '20px' }}>
              Email Notifications Settings
            </MyTypography>
          </Grid>
          <NotificationOptions
            placeholder="Enter the Notications"
            label="Notifications"
            notificationSettings={clinicsNotificationSettings}
            handleChange={handleClinicNotificationChange}
            size={6}
          />
        </>
      ) : null}
      <Grid item xs={12}>
        <MyTypography gutterBottom variant="h4" style={{ marginTop: '20px' }}>
          Notifications
        </MyTypography>
      </Grid>
      <NotificationOptions
        placeholder="Enter the Notications"
        label="Notifications"
        notificationSettings={nonOtpNotificationSettings}
        handleChange={handleNotificationChange}
        size={12}
      />
      <Grid item xs={12}>
        <MyTypography gutterBottom variant="h4" style={{ marginTop: '20px' }}>
          OTP Delivery Preference
        </MyTypography>
        <MyTypography variant="body2" color="text.secondary">
          Choose where to receive your one-time password.
        </MyTypography>
        <MyTypography variant="body2" color="text.secondary">
          At least one OTP channel must remain enabled.
        </MyTypography>
      </Grid>
      <NotificationOptions
        placeholder="Enter OTP Preferences"
        label="OTP Delivery Preference"
        notificationSettings={otpNotificationSettingsWithGuard}
        handleChange={handleNotificationChange}
        size={12}
      />
    </Grid>
  );
}
